// Injects the app's RUM reporter into the @heidi/editor destroy-safety guards.
import { reportDestroyedEditorAccess } from '@/utils/telemetry/editor-observability';
import { configureEditor } from '@heidi/editor/core';

configureEditor({ reportDestroyedEditorAccess });
